export class BedBlock
{
    private readonly hoverColor = "#c8e5f8";

    public setBedEvents(): void
    {
        const $beds = $(".w-bedblock__bed");
        if ($beds.length <= 0)
            return;

        const toggleHoverStyles = (className: string, isEntering: boolean) =>
        {
            $("." + className).each((_, item: HTMLElement) =>
            {
                const useStroke = $(item).hasClass("stroke");
                const property = useStroke ? "stroke" : "fill";

                if (isEntering)
                {
                    const color = $(item).hasClass("white") ? "#ffffff" : this.hoverColor;
                    item.style[property] = color;
                }
                else
                    item.style[property] = "";
            });

            $("li.w-bedblock__bed-hover[data-class='" + className + "']").toggleClass("active", isEntering);
        };

        $beds.find("a").attr("tabindex", -1);

        $(".w-bedblock__bed-hover")
            .attr("tabindex", -1)
            .on("mouseover focusin", function (this: HTMLElement)
            {
                const className = $(this).data("class") as string | undefined;
                if (className)
                    toggleHoverStyles(className, true);
            })
            .on("mouseout focusout", function (this: HTMLElement)
            {
                const className = $(this).data("class") as string | undefined;
                if (className)
                    toggleHoverStyles(className, false);
            });
    }
}

window.addEventListener("load", (event: Event) =>
{
    const bedBlock = new BedBlock();
    bedBlock.setBedEvents();
});
